import React, { useState } from "react";

const EmailSection = ({ email, setEmail, newEmail, setNewEmail }) => {
  const [editingEmail, setEditingEmail] = useState(false);

  const handleEmailChange = (event) => {
    setNewEmail(event.target.value);
  };

  const handleEmailCancel = () => {
    setEditingEmail(false);
    setNewEmail("");
  };

  const handleEmailSave = () => {
    setEmail(newEmail);
    setEditingEmail(false);
    setNewEmail("");
  };

  return (
    <div className="mb-4">
      <h2 className="font-bold text-gray-700 text-lg mb-2">Email Address</h2>
      {editingEmail ? (
        <div>
          <input
            className="w-full border-gray-300 rounded-md shadow-sm mb-2"
            type="text"
            placeholder="Email Address"
            value={newEmail}
            onChange={handleEmailChange}
          />
          <div className="flex justify-end">
            <button
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-l"
              onClick={handleEmailCancel}
            >
              Cancel
            </button>
            <button
              className="text-white bg-black hover:scale-[1.05] transition-all font-bold py-2 px-4 rounded-r"
              onClick={handleEmailSave}
            >
              Save
            </button>
          </div>
        </div>
      ) : (
        <div>
          <p className="text-gray-500 text-sm">
            {email} <span className="font-bold">(Verified)</span>
          </p>
          <p className="text-gray-500 text-sm">
            This is the email address you use to sign in. It's also where we
            send your booking confirmations.
          </p>
          <button
            className="text-blue-500 hover:text-blue-700 text-sm"
            onClick={() => setEditingEmail(true)}
          >
            Edit
          </button>
        </div>
      )}
    </div>
  );
};

export default EmailSection;
